import { FlaskConical, Rows3, Undo2, Workflow } from 'lucide-react';
import { AccessBadge } from '@/modules/back-testing/datasets/tools/tool-access';
import { PillButton } from '@/modules/simulator/ui/pill-button';
import { Segmented } from '@/modules/simulator/ui/segmented';
import { useCustomToolBuilder } from './builder-context';
import type { BuilderView } from './builder-view';

const VIEWS = [
	{ value: 'canvas' as const, label: 'Canvas', icon: Workflow },
	{ value: 'blocks' as const, label: 'Blocks', icon: Rows3 }
];

const HINT: Record<BuilderView, string> = {
	canvas: 'Drag a field onto an argument to pass it on. Steps with no link between them run at the same time.',
	blocks: 'Pick where each argument comes from. Steps run at the same time unless one waits for another.'
};

/** Above the steps, whichever way they are shown: the view switch, how it works, whether the tool writes, undo and the test run. */
export const BuildToolbar = () => {
	const { draft, writes, testing, undo, view, setView } = useCustomToolBuilder();
	return (
		<div className='flex shrink-0 items-center gap-3 border-b border-gray-500 bg-white px-4 py-2'>
			<Segmented options={VIEWS} value={view} onChange={setView} />
			<p className='min-w-0 flex-1 truncate text-[11px] leading-4 text-gray-800'>{draft.steps.length > 0 && HINT[view]}</p>
			{writes && <AccessBadge riskLevel='high' />}
			<PillButton title='Undo (⌘Z)' disabled={!undo.available} onClick={undo.run}>
				<Undo2 className='size-3.5' />
				Undo
			</PillButton>
			{draft.steps.length > 0 && (
				<PillButton aria-pressed={testing.open} onClick={() => testing.setOpen(!testing.open)}>
					<FlaskConical className='size-3.5' />
					Test
				</PillButton>
			)}
		</div>
	);
};
